import StoreSwitcher from 'components/Header/StoreSwitcher/StoreSwitcher';
import { withStoreSwitcherProps } from 'viewModel/header/storeSwitcher/withStoreSwitcherProps';

export default withStoreSwitcherProps(StoreSwitcher);
